var buildModal = document.getElementById("dialog");
var buildSpan = document.getElementsByClassName("dialog_close")[0];

buildSpan.onclick = function () {
  buildModal.style.display = "none";
}

document.addEventListener('DOMContentLoaded', function () {
  window.onclick = function (event) {
    if (event.target == buildModal) {
      buildModal.style.display = "none";
    }
  }
});

function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

const id = getUrlParameter('id');
const baseUrl = 'https://bdsgallery-function.azurewebsites.net/api/builds';
let orderedImages = [];
let updatedBuild;

$.ajax({
  url: baseUrl,
  type: 'GET',
  data: { id: id },
  dataType: 'json',
  success: function (res) {
    res.data.map(async item => {
      if (galleryAdmins.includes(email) || item.approval_status || item.email === email) {
        updatedBuild = item;
        $('.fitment_title').text((item.lift_height ? item.lift_height + ' Lifted ' : '') + item.year + ' ' + item.make + ' ' + item.model);
        if (galleryAdmins.includes(email) || (item.email === email)) {
          $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_delete">Delete</button>');
        }
        if (galleryAdmins.includes(email)) {
          if (item.approval_status == 1) {
            $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_approve" disabled>Approved</button>');
          } else if (item.approval_status == 2) {
            $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_deny" disabled>Denied</button>');
          } else {
            $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_deny">Deny</button><button class="btn btn_build_approve">Approve</button>');
          }
        }

        const images = item.images;
        let sub_html = '<ul>';
        if (galleryAdmins.includes(email)) {
          images.length > 0 ? $('.main_image').append('<img src="' + images[0] + '"><button class="product-form__submit button button--secondary button-text-change btn_set_product_image">Set Product image</button><div id="main_image-msg" style="display: none;" class="thumb-status-message">Please select a product!</div>') : $('.main_image').append(`{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}`)
          images.map((image, k) => {
            if (k == 0) {
              sub_html += '<div class="thumbnail_item"><div class="numbered-checkbox"><input type="checkbox" id="checkbox' + k + '"/><label for="checkbox' + k + '"></label></div><li class="is-active"><img src="' + image + '"></li></div>';
            } else {
              sub_html += '<div class="thumbnail_item"><div class="numbered-checkbox"><input type="checkbox" id="checkbox' + k + '"/><label for="checkbox' + k + '"></label></div><li><img src="' + image + '"></li></div>';
            }
          });
          sub_html += '</ul><a type="button" class="button btn_image_order_confirm" disabled>Confirm</a>';
        } else {
          $('.main_image').append('<img src="' + images[0] + '">');
          images.map((image, k) => {
            if (k == 0) {
              sub_html += '<div class="thumbnail_item"><li class="is-active"><img src="' + image + '"></li></div>';
            } else {
              sub_html += '<div class="thumbnail_item"><li><img src="' + image + '"></li></div>';
            }
          });
          sub_html += '</ul>';
        }

        $('.thumbnail_image').html(sub_html);
        let product_html = '';
        for (const product of item.products || []) {
          const returnedProduct = await makeGraphQLRequest(getProductWithHandle(product.handle));
          if (returnedProduct.data && returnedProduct.data.productByHandle) {
            product_html += '<div class="build_product-item" data-pid="' + returnedProduct.data.productByHandle.id.replace('gid://shopify/Product/', '') + '">' +
              (galleryAdmins.includes(email) ? '<input class="chk_product" type="checkbox"/>' : '') +
              '<a class="product-tile__img-link" href="/products/' + product.handle + '"' +
              '<span class="product-image-container product-image-container-6458" style="width: 300px;">' +
              '<span class="product-image-wrapper" style="padding-bottom: 66.6667%;">' +
              (returnedProduct.data.productByHandle.images.edges.length > 0 ? '<img class="product-image-photo" src="' + returnedProduct.data.productByHandle.images.edges[0].node.originalSrc + '" width="300" height="200"/>' : `<div style="width: 300px; height: 200px;">{{ 'image' | placeholder_svg_tag: 'placeholder-svg' }}</div>`) +
              '</span>' +
              '</span>' +
              '</a>' +
              '<div class="build_product-details">' +
              '<a href="/products/' + product.handle + '">' + returnedProduct.data.productByHandle.title + '</a>' +
              '<p>$' + returnedProduct.data.productByHandle.variants.edges[0].node.price.amount + '</p>' +
              '</div>' +
            '</div>';
          }
        }

        $('.build_product-item_body').append(product_html);

        if (item.username) {
          $('.build_about-section_details').append('<div><h4>Owner:</h4><p>' + item.username + '</p>' + (item.instagram ? '<a href="http://www.instagram.com/' + item.instagram + '" target="_blank"><img src="' + instagram_icon + '"><p style="color: #006bb6;">' + item.instagram + '<p></a>' : '') + '</div>');
        }
        if (item.city_state) $('.build_about-section_details').append('<div><h4>Location:</h4><p>' + item.city_state + '</p></div>');
        $('.build_about-section_details').append('<div><h4>Vehicle:</h4><p>' + (item.year + ' ' + item.make + ' ' + item.model + ' ' + (item.submodel === undefined ? '' : item.submodel) + ' ' + (item.drive_type === undefined ? '' : item.drive_type) + ' ' + (item.fuel_type === undefined ? '' : item.fuel_type)) + '<p></div>');
        if (item.lift_height) $('.build_about-section_details').append('<div><h4>Lift Height:</h4><p>' + item.lift_height + '<p></div>');
        if (item.diameter || item.width || item.offset || item.wheel_brand || item.wheel_model) {
          $('.build_about-section_details').append('<div><h4>Wheels:</h4><p>' + (item.diameter ? item.diameter : '') + (item.width ? (' x ' + item.width) : '') + ((item.offset || item.wheel_brand || item.wheel_model) ? ', ' : '') + (item.offset ? item.offset : '') + (item.wheel_brand ? (' | ' + item.wheel_brand) : '') + ' ' + (item.wheel_model ? item.wheel_model : '') + '<p></div>');
        }
        if (item.tire_size1 || item.tire_size2) {
          if (item.tire_size1 && item.tire_size1.includes('"')) {
            $('.build_about-section_details').append('<div><h4>Tires:</h4><p>' + (item.tire_size1 ? item.tire_size1 : '') + (item.tire_size2 ? (' x ' + item.tire_size2) : '') + (item.tire_brand ? (' | ' + item.tire_brand) : '') + (item.tire_model ? (' ' + item.tire_model) : '') + '<p></div>');
          } else {
            $('.build_about-section_details').append('<div><h4>Tires:</h4><p>' + (item.tire_size1 ? item.tire_size1 : '') + (item.tire_size2 ? (' x ' + item.tire_size2) : '') + (item.diameter ? (' R ' + item.diameter) : '') + (item.tire_brand ? (' | ' + item.tire_brand) : '') + (item.tire_model ? (' ' + item.tire_model) : '') + '<p></div>');
          }
        }
        if (item.triming) $('.build_about-section_details').append('<div><h4>Trimming:</h4><p>' + item.triming + '<p></div>');
        if (item.comments) $('.build_about-section_details').append('<div><h4>Accessories:</h4><p>' + item.comments + '<p></div>');

        $('#album-rating').text(item.votes.length);
      } else {
        window.location.href = '/pages/gallery';
      }
    });
  }
});

function getProductWithHandle(handle) {
  return `query {
    productByHandle(handle: "${handle}") {
      id
      title
      variants(first: 1) {
        edges {
          node {
            id
            title
            price {
              amount
              currencyCode
            }
          }
        }
      }
      images(first: 1) {
        edges {
          node {
            originalSrc
            altText
          }
        }
      }
    }
  }`
}

async function makeGraphQLRequest(query) {
  const response = await fetch(
    'https://bds-suspension.myshopify.com/api/2023-10/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': 'c79e6573ca3d58a17cfceb713f86fa0b',
    },
    body: JSON.stringify({ query }),
  }
  )
  const json = await response.json();
  return json;
}

$(document).on('click', '.thumbnail_image ul li img', function () {
  $('.thumbnail_image ul li').removeClass('is-active');
  $(this).parent().addClass('is-active');
  $('.main_image img').attr('src', $(this).attr('src'));
});

$(document).on('click', '.btn_build_approve', function () {
  progress();
  const postData = { id: id, approval: 1 };
  $.ajax({
    url: baseUrl,
    type: 'POST',
    data: JSON.stringify(postData),
    dataType: 'json',
    success: function (res) {
      $('.shop_product-section .admin_btns_wrapper').html('');
      $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_approve" disabled>Approved</button>');
      $.unblockUI();
      if (document.referrer.includes('/account')) {
        window.location.href = '/account';
      } else {
        window.location.href = '/pages/gallery';
      }
    }, error: function () {
      $.unblockUI();
    }
  });
});

$(document).on('click', '.btn_build_deny', function () {
  progress();
  const postData = { id: id, approval: 2 };
  $.ajax({
    url: baseUrl,
    type: 'POST',
    data: JSON.stringify(postData),
    dataType: 'json',
    success: function (res) {
      $('.shop_product-section .admin_btns_wrapper').html('');
      $('.shop_product-section .admin_btns_wrapper').append('<button class="button button--secondary button-text-change btn_build_deny" disabled style="margin: 0 auto;">Denied</button>');
      $.unblockUI();
      if (document.referrer.includes('/account')) {
        window.location.href = '/account';
      } else {
        window.location.href = '/pages/gallery';
      }
    }
  });
});

$(document).on('click', '.thumbnail_item input', function () {
  let lastNumber = 0;
  if ($(this).is(':checked')) {
    $('.numbered-checkbox input').each(function () {
      if ($(this).is(':checked')) {
        lastNumber++;
      }
    });
    $(this).parent().find('label').text(lastNumber);
    orderedImages.push($(this).parent().parent().find('img').attr('src'));
  } else {
    const n = parseInt($(this).parent().find('label').text());
    $('.numbered-checkbox input').each(function () {
      if (parseInt($(this).parent().find('label').text()) > n) {
        $(this).parent().find('label').text(parseInt($(this).parent().find('label').text()) - 1);
      }
    });
    $(this).parent().find('label').text('');
    orderedImages.splice(n - 1, 1);
  }

  if (allChecked()) {
    $('.btn_image_order_confirm').attr('disabled', false);
  } else {
    $('.btn_image_order_confirm').attr('disabled', true);
  }
});

function allChecked() {
  let allAreChecked = true;

  $('.numbered-checkbox input').each(function () {
    if (!$(this).is(':checked')) {
      allAreChecked = false;
    }
  });

  return allAreChecked;
}

$(document).on('click', '.btn_image_order_confirm', function () {
  progress();
  updatedBuild.images = orderedImages;
  $.ajax({
    url: "https://bdsgallery-function.azurewebsites.net/api/builds",
    type: 'PUT',
    data: JSON.stringify(updatedBuild),
    dataType: 'json',
    success: function (res) {
      const images = res[0].images;
      if (images.length > 0) {
        $('.main_image').html('<img src="' + images[0] + '"><button class="product-form__submit button button--secondary button-text-change btn_set_product_image">Set Product image</button>');
        let sub_html = '';
        images.map((image, k) => {
          if (k == 0) {
            sub_html += '<div class="thumbnail_item"><div class="numbered-checkbox"><input type="checkbox" id="checkbox' + k + '"/><label for="checkbox' + k + '"></label></div><li class="is-active"><img src="' + image + '"></li></div>';
          } else {
            sub_html += '<div class="thumbnail_item"><div class="numbered-checkbox"><input type="checkbox" id="checkbox' + k + '"/><label for="checkbox' + k + '"></label></div><li><img src="' + image + '"></li></div>';
          }
        });
        $('.thumbnail_image ul').html(sub_html);
        if (galleryAdmins.includes(email)) {
          $('.btn_set_product_image').show();
        }
      }
      $('.btn_image_order_confirm').attr('disabled', true);
      orderedImages = [];
      $.unblockUI();
    }, error: function (res) {
      $.unblockUI();
      if (res.status === 200 && res.statusText === 'OK') {
        console.log('failed', res);
      }
    }
  });
});

$(document).on('click', '.btn_set_product_image', function () {
  let pIds = '';
  const image = $('.main_image img').attr('src');
  $('.chk_product').each(function () {
    if ($(this).is(':checked')) {
      pIds += $(this).parent().data('pid') + ',';
    }
  });

  if (pIds !== '' && image) {
    progress();
    $.ajax({
      url: "https://bdsgallery-function.azurewebsites.net/api/set_images",
      type: 'POST',
      data: JSON.stringify({ ids: pIds, path: image }),
      dataType: 'json',
      success: function (res) {
        $.unblockUI();
      }, error: function (res) {
        $.unblockUI();
      }
    });
  } else {
    $('#main_image-msg').show();
    setTimeout(() => {
      $('#main_image-msg').hide();
    }, 3000);
  }
});

$('.imgalbum__rating-button').on('click', function () {
  const userId = generateUniqueIdentifier();
  if (userId) {
    $.ajax({
      url: baseUrl,
      type: 'POST',
      data: JSON.stringify({ id: id, userId: userId }),
      dataType: 'json',
      success: function (res) {
        if (parseInt($('#album-rating').text()) === res[0].votes.length) {
          $('#rating-msg').show();
          setTimeout(() => {
            $('#rating-msg').hide();
          }, 3000);
        } else {
          $('#album-rating').text(res[0].votes.length);
        }
      }
    });
  }
});

function generateUniqueIdentifier() {
  let uniqueId = localStorage.getItem('uniqueId');

  if (!uniqueId) {
    uniqueId = generateUUID();
    localStorage.setItem('uniqueId', uniqueId);
  }

  return uniqueId;
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}

$(document).on('click', '.btn_build_delete', function () {
  buildModal.style.display = "block";
});

$('.btn_confirm').on('click', function () {
  buildModal.style.display = "none";
  progress();
  $.ajax({
    url: baseUrl,
    type: 'DELETE',
    data: JSON.stringify({ id: id }),
    dataType: 'json',
    success: function (res) {
      $.unblockUI();
      if (document.referrer.includes('/account')) {
        window.location.href = '/account';
      } else {
        window.location.href = '/pages/gallery';
      }
    }, error: function (xhr, status, error) {
      console.log("Error:", status, error);
    }
  });
});

$('.btn_cancel').on('click', function () {
  buildModal.style.display = "none";
});